import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Globe, ArrowLeft, Plus, FileText, Trash2, Upload, File, Image, CheckCircle } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const DocumentsPage = () => {
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newDoc, setNewDoc] = useState({ name: "", doc_type: "passport" });

  useEffect(() => {
    const loadDocuments = async () => {
      try { const data = await api.getDocuments(); setDocuments(data); } catch (error) { toast.error("Unable to load documents"); }
      finally { setIsLoading(false); }
    };
    loadDocuments();
  }, []);

  const handleAddDocument = async () => {
    try {
      const doc = await api.addDocument(newDoc); setDocuments([...documents, doc]);
      setNewDoc({ name: "", doc_type: "passport" }); setDialogOpen(false); toast.success("Document added");
    } catch (error) { toast.error("Failed to add document"); }
  };

  const handleDeleteDocument = async (docId) => {
    try { await api.deleteDocument(docId); setDocuments(documents.filter(d => d.doc_id !== docId)); toast.success("Removed"); }
    catch (error) { toast.error("Failed to delete"); }
  };

  if (isLoading) return <div className="min-h-screen flex items-center justify-center"><div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 glass border-b p-4"><div className="max-w-7xl mx-auto flex items-center justify-between"><div className="flex items-center gap-4"><Button variant="ghost" size="icon" onClick={() => navigate(-1)}><ArrowLeft /></Button><div className="flex items-center gap-2"><Globe className="h-6 w-6 text-primary" /><span className="font-bold text-lg font-['Manrope']">Nomad Roadmap</span></div></div><Link to="/dashboard"><Button variant="outline" size="sm">Dashboard</Button></Link></div></header>
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8"><div><h1 className="text-2xl md:text-3xl font-bold font-['Manrope'] mb-2">Documents</h1><p className="text-muted-foreground">Manage your documents in one place.</p></div>
          <Dialog open={dialogOpen} onOpenChange={setDialogOpen}><DialogTrigger asChild><Button className="bg-primary hover:bg-primary/90"><Plus className="h-4 w-4 mr-1" />Add Document</Button></DialogTrigger><DialogContent><DialogHeader><DialogTitle>Add Document</DialogTitle></DialogHeader><div className="space-y-4 pt-4"><div className="space-y-2"><Label>Document Name</Label><Input value={newDoc.name} onChange={e => setNewDoc({...newDoc, name: e.target.value})} /></div><Button onClick={handleAddDocument} className="w-full">Add Document</Button></div></DialogContent></Dialog></div>
        <div className="grid gap-4">{documents.map((doc) => (<Card key={doc.doc_id} className="border-border/50 hover:shadow-md transition-all"><CardContent className="p-4 flex items-center gap-4"><div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary"><File /></div><div className="flex-1"><h3 className="font-medium">{doc.name}</h3><p className="text-sm text-muted-foreground capitalize">{doc.doc_type}</p></div><Button variant="ghost" size="icon" onClick={() => handleDeleteDocument(doc.doc_id)} className="text-muted-foreground hover:text-destructive"><Trash2 /></Button></CardContent></Card>))}</div>
      </main>
    </div>
  );
};

export default DocumentsPage;